// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__321m8","footer":"ModalFilter_footer__3aMIn"};